import { useAuthStore, selectIsAuthed } from '@/stores/authStore';

/**
 * Convenience hook bundling the common auth state + actions.
 *
 *   const { user, isAuthed, login, logout } = useAuth();
 */
export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const isAuthed = useAuthStore(selectIsAuthed);
  const login = useAuthStore((s) => s.login);
  const logout = useAuthStore((s) => s.logout);
  const setUser = useAuthStore((s) => s.setUser);
  return { user, isAuthed, login, logout, setUser };
}
